import { TUserAccountInfo } from 'types/state';
import { M8AccountInfo } from 'services/production/types';
import { normalizeM8RoleName } from 'services/production/utils/normalizeM8RoleName';
import { normalizeM8AuthorizationType } from 'services/production/utils/normalizeM8AuthorizationType';

export const normalizeM8AccountInfo = (info: M8AccountInfo) => ({
  toUserAccountInfo(): TUserAccountInfo {
    return {
      email: info.email,
      id: info.id,
      roles: info.roleName.map((roleName) =>
        normalizeM8RoleName(roleName).toUserRole()
      ),
      authProvider: info.lastAuthorizationType
        ? normalizeM8AuthorizationType(
            info.lastAuthorizationType
          ).toUserAuthProvider()
        : 'UNKNOWN',
    };
  },
});
